import React from 'react';

const BeyondTheTip = () => {
  return (
    <div>
      <h1>Beyond the Tip</h1>
      <img src="/beyond-the-tip-cover.jpg" alt="Beyond The Tip Cover" />
      <p>
        Iceberger Don Warner has published a new book about the Brighton
        Icebergers, called Beyond The Tip Tales of the Icebergers of Brighton.
      </p>
      <p>
        The book is 230 pages long, with 228 photos and chronicles the
        swimming histories of 152 Iceberger swimmers. In addition, the book
        also includes numerous full colour photos of certain Iceberger events,
        some very 'cool' and very 'cold' places to swim and other information
        pertinent to our hardy winter swimming group.
      </p>
      <p>
        If you wish to order a copy of ‘Beyond The Tip’ by Don Warner - the cost
        is $35.00 + postage of $12.00 to anywhere in Australia.
      </p>
      <p>
        Please <a href="mailto:don.g.warner@gmail.com?subject=BOOK ORDER">click here</a> and submit your order request directly to Don along
        with your contact details and mailing address.
      </p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default BeyondTheTip;
